export default __webpack_public_path__ + "static/siblingdiscount-3a22fed6b8ca54dcd7f07a85b286facd.png";